// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__5us_j","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3v-io"};